// ============================================== Mobile Navigation //


var mobileNav = {
    init: function () {
        var navTarget = $('.header:first');
        var menuTarget = navTarget.find('.main-nav ul:first');
        var menuPos = 0;

        var menuHeight = menuTarget.outerHeight();

        // Menu open

        $('.header .icon-menu:first').click(function (e) {
            e.preventDefault();

            if(navTarget.hasClass('mob-nav-open')){
                // remove height from element
                menuTarget.parent().css({'max-height': 0});
            }else{
                // add height to element
                menuTarget.parent().css({'max-height': menuHeight});
            }
            navTarget.toggleClass('mob-nav-open');
        });

    },

    destroy: function () {

        var navTarget = $('.header:first');
        var menuTarget = navTarget.find('.main-nav ul:first');
        //
        menuTarget.parent().removeAttr("style");
        //
        navTarget.removeClass('mob-nav-open');
        //
        $('.header .icon-menu:first').unbind('click');
        //
    }
}

// ============================================== Banner responsive images //

var bannerImg = {
    init: function (target) {
        var imgUrl = target.data('img-desktop');
        if(imgUrl && imgUrl!=''){
            target.css('background-image', 'url(' + imgUrl + ')');
        }
    },

    destroy: function (target) {
        //console.log('bannerImg destroy');
        target.removeAttr("style");
    }
}

// ============================================== Select dropdown //

var setSelect = {
    init: function ($target) {


        // Work out if an option is already selected
        var setSelectedIndex = 0;
        var thisSelectedIndex = $target.prop('selectedIndex');

        if (thisSelectedIndex > 0) {
            // offset selected index
            setSelectedIndex = thisSelectedIndex+1;
        }


        // Chosen needs a placeholder data attr and an empty first option
        var firstOption = $target.find('option:eq(0)');

        if (firstOption.attr('value') == null || firstOption.attr('value') == '') {
            $target.attr('data-placeholder', firstOption.text());
            firstOption.remove();
            // offset selected index back again
            if(setSelectedIndex>0){
                setSelectedIndex--;
            }
        }


        var firstOption = '<option></option>';

        if ($target.attr('multiple')) {
            firstOption = '<option disabled></option>';
        }

        $target.prepend(firstOption);

        // Select 'selected' option again (if not a multi select)
        if(!$target.attr('multiple')){
            $target.find('option:eq('+setSelectedIndex+')').prop('selected', true);
        }


        // ============================================== Initialise Chosen  //

        $target.chosen({
            disable_search: true,
            width: "100%",
            allow_single_deselect: true
        }).change(function () {
            if ($target.prop('required')) {
                if ($target.closest('form').attr('novalidate')) {
                    $(this).valid(); // triggering validator plugin if initialised
                }
            }
        });

    },
    destroy: function () {
    }
};


// ============================================== Form Validation defaults  //

jQuery.validator.setDefaults({
    focusInvalid: false, // so we can smooth scroll
    ignore: ':hidden:not(.select:visible select:hidden)', // Ignore hidden fields except selects (within visible divs) which might be hidden by Chosen
    errorPlacement: function(error, element) {
        if(element.parent().hasClass('select')) {
            error.insertAfter(element.parent()); // If I'm a chosen select then put error after block
        } else if (element.parent().hasClass('checkbox')) {
            error.insertAfter(element.closest('.form-group').find('.checkbox:last label:first')); // If I'm a custom check then put error after last label
        } else if (element.parent().hasClass('radio')) {
            error.insertAfter(element.closest('.form-group').find('.radio:last label:first')); // If I'm a custom radio then put error after last label
        } else {
            error.insertAfter(element);
        }
    },
    highlight: function(element, errorClass, validClass) {
        $(element).closest('.form-group').addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function(element, errorClass, validClass) {
        $(element).closest('.form-group').addClass(validClass).removeClass(errorClass);
    },
    invalidHandler: function(form, validator) {
        if (!validator.numberOfInvalids()){
            return;
        }
        $('html, body').animate({
            scrollTop: $(validator.errorList[0].element).offset().top - 110 // Account for possible sticky header
        }, 300, 'easeInOutCubic');
    },
    submitHandler: function (form) {
        form.submit();
    }
});



// ============================================== Submit enquiry  //

var submitAjaxForm = function(target){
    // Show spinner after a short time
    var $spinner = target.find('.form-submit .ajax-spinner');
    var spinnerTime = setTimeout(function(){
        $spinner.css({'display':'inline-block'});
    }, 200);
    //
    // Disable button
    var $submitBtn = target.find('.form-submit .btn');
    $submitBtn.prop('disabled', true);
    //
    // Get submit URL from action or data-ajax-submit (if it exists)
    var url = target.data('ajax-submit') ? target.data('ajax-submit') : target.attr('action');
    //
    //Create empty paramter object
    var params = {};
    //
    // Trigger AJAX response
    params['ajax'] = 1;
    //
    //Fill parameter object with values from form fields
    var formdata = target.serializeArray();
    $(formdata ).each(function(index, obj){
        params[obj.name] = obj.value;
    });
    //
    //Make the ajax call to server with the data
    $.post(url,params,function(data){
        //After completion, react to the response.
        var response = $.parseJSON(data);
        //
        // hide spinner
        clearTimeout(spinnerTime);
        $spinner.hide();
        // Enable button
        $submitBtn.prop('disabled', false);
        // Dom elements
        var $thisContainer = target.find('.form-container:first');
        var $thisContainerInner = $thisContainer.find('.form-container-inner:first');
        var $thisContainerResult = $thisContainer.find('.form-container-result:first');
        //If successful, update the UI to show 'enquiry has been received etc.'
        $thisContainer.css({'height': $thisContainer.outerHeight()});
        //
        // Scroll to top of form
        $('html, body').animate({
            scrollTop: target.offset().top - 110 // Take into account possible floating header
        }, 300, 'easeInOutCubic');
        //
        if(response.status == 'success'){
            // If success fade in success message
            $thisContainerInner.fadeOut(200, function(){
                // If html is returned put it into message
                if(response.html){
                    $thisContainerResult.html(response.html);
                }
                // show message
                $thisContainerResult.fadeIn(300);
            });
        }else{
            //If error, update UI with error message
            $thisContainerInner.fadeOut(200, function(){
                // If html is returned put it into message
                if(response.html){
                    $thisContainerResult.html(response.html);
                }else{
                    $thisContainerResult.html('<p>There was an error, please try again later</p>');
                }
                // show message
                $thisContainerResult.fadeIn(300);
            });
        }
    });
}



var freeformSubmitAjax = function(target){

    // Dom elements
    var $thisContainer = target.find('.form-container:first');
    var $thisContainerInner = $thisContainer.find('.form-container-inner:first');
    var $thisContainerResult = $thisContainer.find('.form-container-result:first');
    //If successful, update the UI to show 'enquiry has been received etc.'
    $thisContainer.css({'height': $thisContainer.outerHeight()});
    // Scroll to top of form
    $('html, body').animate({
        scrollTop: target.offset().top - 110 // Take into account possible floating header
    }, 300, 'easeInOutCubic');

    $.post(
        //form url (Freeform autodetects ajax)
        target.attr('action'),
        //form params
        target.serialize(),
        //data handler
        function(data) {

            if (data.success == false) {
                //If error, update UI with error message
                $thisContainerInner.fadeOut(200, function(){
                    $thisContainerResult.html('<p>There was an error, please try again later</p>');
                    $thisContainerResult.fadeIn(300);
                });

            }else if (data.success){
                $thisContainerInner.fadeOut(200, function(){
                    // show message
                    $thisContainerResult.fadeIn(300);
                });
            }

         }
    );

}

$(document).ready(function () {

    // Mobile events
    enquire.register("screen and (max-width:784px)", {

        // Triggered when a media query matches.
        match : function() {
            // slight delay to ensure correct element height is recorded
            setTimeout(function(){
              mobileNav.init();
            }, 200);
        },

        // Triggered when the media query transitions
        unmatch : function() {
            mobileNav.destroy();
        }

    });


    // Desktop events
    enquire.register("screen and (min-width:784px)", {

        // Triggered when a media query matches.
        match : function() {
            $('.banner').each(function(){
                bannerImg.init($(this));
            });
        },

        // Triggered when the media query transitions
        unmatch : function() {
            $('.banner').each(function(){
                bannerImg.destroy($(this));
            });
        }

    });


    // Image carousel

    if($('.carousel li').length > 1){
        $('.carousel').slick({
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true
            //appendArrows: '.carousel-nav-container .carousel-nav',
            //appendDots: '.carousel-nav-container .carousel-nav'
        });

    }

    // Select dropdowns
    $('.select').each(function () {
        setSelect.init($(this).find('select:first'));
    });


    //Form Validation - Destination form / Contact Form
    $('#guide-form, #contact-form').validate({
        submitHandler: function (form) {
            freeformSubmitAjax($(form));
        }
    });



});
